var kandcojewels;
(function($) {
  "use strict";
  kandcojewels = (function() {
    return {
      init: function() {
        // Collection
        this.collection();
        this.collectionFilter();
      },

      // Collection
      collection: function() {
        $("body").on("click", ".js-collection-next-page", function () {
          var href = $(this).attr("href");
          $(".js-collection-action").remove();
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-collection-row').append($(data).find('.js-collection-row').html());
              mySwiper = new Swiper('.swiper-product-image', change_settings);

            $(".static-next.swiper-arrow").click(function(){
   $(this).closest('.product-grid-item__image').find('.swiper-button-next').trigger('click');;
  });

    $(".static-prev.swiper-arrow").click(function(){
     $(this).closest('.product-grid-item__image').find('.swiper-button-prev').trigger('click');;
  });


          });
          return false;
        });
      },

      collectionFilter: function() {

         $(".js-toggle-filter-widget").click(function() {
          $(this).parent().parent().find(".js-filter-widget").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().find(".js-filter-widget-content").slideToggle(500);
        });

        $(".js-filter-widget.active").each(function () {
          $(this).find(".js-filter-widget-content").slideToggle(500);
        });
        
        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".js-sort-by").attr("data-value");
        var tags = [];
        $("input.tag").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if($(".js-collection-items").hasClass("search")) {
            return $(".js-collection-items").attr("data-url") + "&sort_by=" + Shopify.queryParams.sort_by;
          } else {
            if(Shopify.queryParams.constraint == '') {
              return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by;
            } else {
              return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by;
            }
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function() {
              $(".js-collection").addClass("loading");
            },
            success: function(result) {
              //  console.log(result);
              //alert("sort");
             /* var title = result.match("<title>(.*?)</title>")[1];
             
              History.pushState({
                param: Shopify.queryParams
              }, title, url);*/

              
              $(".js-collection").html($(result).find(".js-collection").html());
              $(".js-collection").removeClass("loading");

                history.pushState({page: url}, url, url);
            },
            error: function() {
              $(".js-collection").removeClass("loading");
            }
          })
        }

        
      $("input.tag").change(function () {
        var tags = [];
        $("input.tag").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        $(".filter__action").addClass("active");
        Shopify.queryParams.constraint = tags.join("+");
        filterGetContent(filterCreateUrl());
        return false;
      });

        $("body").on("click", ".js-open-sort-by", function(y) {
          $(".js-sort-by-dropdown").toggleClass("active");
          return false;
        });

        $("body").on("click", ".js-change-sort-by", function(y) {
          Shopify.queryParams.sort_by = $(this).attr("data-value");
          filterGetContent(filterCreateUrl());
          $(".js-sort-by").html($(this).html());
          $(".js-sort-by-dropdown").removeClass("active");
          return false;
        });
      
        
        
        $("body").on("click", ".js-toggle-filter-widget[data-option='option1']", function(y) {
          $(this).toggleClass("active");
          $(".js-toggle-filter-widget[data-option='option2']").removeClass("active");
          $(".js-filter-widget-content[data-option='option2']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option3']").removeClass("active");
          $(".js-filter-widget-content[data-option='option3']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option4']").removeClass("active");
          $(".js-filter-widget-content[data-option='option4']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option5']").removeClass("active");
          $(".js-filter-widget-content[data-option='option5']").removeClass("active");
          $(".filter__overlay[data-option='option1']").toggleClass("active");
          $(".filter__overlay[data-option='option2']").removeClass("active");
          $(".filter__overlay[data-option='option3']").removeClass("active");
          $(".filter__overlay[data-option='option4']").removeClass("active");
          $(".filter__overlay[data-option='option5']").removeClass("active");
          $(this).parent().find(".js-filter-widget-content").toggleClass("active");
          return false;
        });

        $("body").on("click", ".js-toggle-filter-widget[data-option='option2']", function(y) {
          $(this).toggleClass("active");
          $(".js-toggle-filter-widget[data-option='option1']").removeClass("active");
          $(".js-filter-widget-content[data-option='option1']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option3']").removeClass("active");
          $(".js-filter-widget-content[data-option='option3']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option4']").removeClass("active");
          $(".js-filter-widget-content[data-option='option4']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option5']").removeClass("active");
          $(".js-filter-widget-content[data-option='option5']").removeClass("active");
          $(".filter__overlay[data-option='option2']").toggleClass("active");
          $(".filter__overlay[data-option='option1']").removeClass("active");
          $(".filter__overlay[data-option='option3']").removeClass("active");
          $(".filter__overlay[data-option='option4']").removeClass("active");
          $(".filter__overlay[data-option='option5']").removeClass("active");
          $(this).parent().find(".js-filter-widget-content").toggleClass("active");
          return false;
        });

        $("body").on("click", ".js-toggle-filter-widget[data-option='option3']", function(y) {
          $(this).toggleClass("active");
          $(".js-toggle-filter-widget[data-option='option1']").removeClass("active");
          $(".js-filter-widget-content[data-option='option1']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option2']").removeClass("active");
          $(".js-filter-widget-content[data-option='option2']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option4']").removeClass("active");
          $(".js-filter-widget-content[data-option='option4']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option5']").removeClass("active");
          $(".js-filter-widget-content[data-option='option5']").removeClass("active");
          $(".filter__overlay[data-option='option3']").toggleClass("active");
          $(".filter__overlay[data-option='option2']").removeClass("active");
          $(".filter__overlay[data-option='option1']").removeClass("active");
          $(".filter__overlay[data-option='option4']").removeClass("active");
          $(".filter__overlay[data-option='option5']").removeClass("active");
          $(this).parent().find(".js-filter-widget-content").toggleClass("active");
          return false;
        });

        $("body").on("click", ".js-toggle-filter-widget[data-option='option4']", function(y) {
          $(this).toggleClass("active");
          $(".js-toggle-filter-widget[data-option='option1']").removeClass("active");
          $(".js-filter-widget-content[data-option='option1']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option3']").removeClass("active");
          $(".js-filter-widget-content[data-option='option3']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option2']").removeClass("active");
          $(".js-filter-widget-content[data-option='option2']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option5']").removeClass("active");
          $(".js-filter-widget-content[data-option='option5']").removeClass("active");
          $(".filter__overlay[data-option='option4']").toggleClass("active");
          $(".filter__overlay[data-option='option2']").removeClass("active");
          $(".filter__overlay[data-option='option3']").removeClass("active");
          $(".filter__overlay[data-option='option1']").removeClass("active");
          $(".filter__overlay[data-option='option5']").removeClass("active");
          $(this).parent().find(".js-filter-widget-content").toggleClass("active");
          return false;
        });

        $("body").on("click", ".js-toggle-filter-widget[data-option='option5']", function(y) {
          $(this).toggleClass("active");
          $(".js-toggle-filter-widget[data-option='option1']").removeClass("active");
          $(".js-filter-widget-content[data-option='option1']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option2']").removeClass("active");
          $(".js-filter-widget-content[data-option='option2']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option3']").removeClass("active");
          $(".js-filter-widget-content[data-option='option3']").removeClass("active");
          $(".js-toggle-filter-widget[data-option='option4']").removeClass("active");
          $(".js-filter-widget-content[data-option='option4']").removeClass("active");
          $(".filter__overlay[data-option='option5']").toggleClass("active");
          $(".filter__overlay[data-option='option2']").removeClass("active");
          $(".filter__overlay[data-option='option3']").removeClass("active");
          $(".filter__overlay[data-option='option4']").removeClass("active");
          $(".filter__overlay[data-option='option1']").removeClass("active");
          $(this).parent().find(".js-filter-widget-content").toggleClass("active");
          return false;
        });


        $("body").on("click", ".filter__overlay", function(y) {
         // alert("hello");
           $(this).removeClass("active");
          $(".js-toggle-filter-widget").removeClass("active");
          $(".js-filter-widget-content").removeClass("active");
          return false;
        });

        
        

        $("body").on("click", ".js-apply-filters", function(y) {
          var tags = [];
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          $(".js-filter").removeClass("active");
          return false;
        });

        $("body").on("click", ".js-reset-filters", function(y) {
          var tags = [];
          $("input.tag").each(function () {
            $(this).prop("checked", false);
          });
          $(".filter__overlay").removeClass("active");
          $(".js-toggle-filter-widget").removeClass("active");
          $(".js-filter-widget-content").removeClass("active");
          
          $(".filter__action").removeClass("active");
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });

        $("body").on("click", ".js-open-product-filter", function(y) {
          $(".js-filter").addClass("active");
          return false;
        });

        $("body").on("click", ".js-close-filter", function(y) {
          $(".js-filter").removeClass("active");
          return false;
        });
      }

    

       }
  })();
})(jQuery);

$(document).ready(function() {
  kandcojewels.init();
});


if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      kandcojewels.init();
    }).on('shopify:section:unload', function() {
      kandcojewels.init();
    }).on('shopify:section:select', function() {
      kandcojewels.init();
    }).on('shopify:section:deselect', function() {
      kandcojewels.init();
    }).on('shopify:block:select', function() {
      kandcojewels.init();
    }).on('shopify:block:deselect', function() {
      kandcojewels.init();
    });
}




